<template>
  <div>
    <v-dialog
      v-model="dialog"
      transition="dialog-bottom-transition"
      content-class="bonus-fullscreen-dialog"
    >
      <v-card class="rounded-0">
        <v-card-title class="v-card--material__header v-sheet theme--dark rounded-0 text-left green text-h5 pl-3">
          <v-hover v-slot="{ hover }">
            <v-icon
              v-text="'mdi-close'"
              :color="'green lighten-' + (hover ? 5 : 3)"
              class="mr-3"
              @click="dialog = false"
              v-ripple
            />
          </v-hover>
          Create/Update Bonus
        </v-card-title>

        <v-card-text>
          <v-stepper
            v-model="step"
            class="bt-stepper col-12 my-5 pa-0 no-background"
          >
            <v-stepper-header class="">
              <template v-for="s of steps">
                <v-divider v-if="s.step != 1" class="mx-0" />
                <v-stepper-step
                  :editable="s.editable"
                  :complete="s.completed"
                  :step="s.step"
                  :key="'stepper' + s.step"
                  class="py-3 rounded-8"
                >
                  {{ s.title }}
                </v-stepper-step>
              </template>
            </v-stepper-header>
          </v-stepper>

          <component
            v-for="s of steps"
            :key="'bonus-stepper-' + s.step"
            :is="s.component || 'Settings'"
            :expand="step == s.step"
            :title="s.title"
            :step="s.step"
            :games="games ? (games[s.games] || [] ): []"
            :brands="brands ? (brands[s.games] || [] ): []"
            :systems="systems ? (systems[s.games] || [] ): []"
            :extvalid.sync="s.valid"
            :exteditable.sync="s.editable"
            :extcompleted.sync="s.completed"
            v-model="s.form"
            :types="types"
            :next="next"
          />

        </v-card-text>

        <v-card-actions>
          <v-btn
            color="warning darken-1"
            outlined
            @click="dialog = false"
          >
            Close
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            outlined
            :disabled="!(steps.optional.valid && steps.currency.valid && steps.settings.valid)"
            @click="saveBonus"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { API } from '@/utils/api'
  import { filter, map, uniq, reduce, cloneDeep } from 'lodash'

  export default {

    props: {
      value: {},
      extdialog: { default: () => false },
      add_bonus: {},
    },

    components: {
      Settings: () => import('@/components/bonus-tools/bonus/forms/Settings'),
      Optional: () => import('@/components/bonus-tools/bonus/forms/Optional'),
      Currency: () => import('@/components/bonus-tools/bonus/forms/Currency'),
    },

    data: () => ({
      item: {},
      types: {
        casino: {
          name: 'Casino',
          type: 'casino',
          sticky: true,
          wager: true,
          max_release: true,
          rollover_type: true,
          exclusive_game: true,
          exclusive_brand: true,
          exclusive_system: true,
          deposit_amount_percent: true,
        },
        sport: {
          name: 'Sport',
          type: 'sport',
          wager: true,
          bonus_type: true,
          rollover_type: true,
          release_type: true,
          sticky: true,
          deposit_amount_percent: true,
          max_release: true,
        },
        overdraft: {
          name: 'Overdraft',
          type: 'overdraft',
          max_release: true,
          exclusive_game: true,
          exclusive_brand: true,
          exclusive_system: true,
        },
        freespins: {
          name: 'Freespins',
          type: 'freespins',
          sticky: true,
          wager: true,
          max_fs_win: true,
          max_release: true,
          game: true,
          exclusive_game: true,
          exclusive_brand: true,
          exclusive_system: true,
        },
      },

      step: 1,
      steps: {
        settings: {
          title: 'Settings',
          component: 'Settings',
          step: 1,
          valid: false,
          form: {},
          editable: false,
          completed: false,
          games: 'freespins'
        },
        currency: {
          title: 'Currency',
          component: 'Currency',
          step: 2,
          valid: false,
          form: {},
          editable: false,
          completed: false,
        },
        optional: {
          title: 'Optional',
          component: 'Optional',
          step: 3,
          valid: false,
          form: {},
          editable: false,
          completed: false,
          games: 'all'
        }
      },

      games: { all: [], freespins: [] },
      brands: { all: [], freespins: [] },
      systems: { all: [], freespins: [] },
    }),

    methods: {
      reset () {
        this.step = 1

        this.$set(this.steps.settings, 'form', {})
        this.$set(this.steps.settings, 'editable', false)
        this.$set(this.steps.settings, 'completed', false)
        this.$set(this.steps.settings, 'valid', false)

        this.$set(this.steps.currency, 'form', {})
        this.$set(this.steps.currency, 'editable', false)
        this.$set(this.steps.currency, 'completed', false)
        this.$set(this.steps.currency, 'valid', false)

        this.$set(this.steps.optional, 'form', {})
        this.$set(this.steps.optional, 'editable', false)
        this.$set(this.steps.optional, 'completed', false)
        this.$set(this.steps.optional, 'valid', false)
      },

      saveBonus () {
        let item = {
          settings: cloneDeep(this.steps.settings.form),
          currency: cloneDeep(this.steps.currency.form),
          optional: cloneDeep(this.steps.optional.form),
        }

        if (item.currency.amount_in_percent) {
          delete item.currency.amounts
        } else {
          delete item.currency.amount_percent
        }

        for (let k in item.currency.options) {
          for (let key of [ 'max_fs_win', 'max_release' ]) {
            if (item.currency.options[k][key]) {

              if (!item.currency[key]) {
                item.currency[key] = []
              }

              item.currency[key].push({
                currency: item.currency.options[k].currency,
                amount: item.currency.options[k][key]
              })

            }
          }
        }

        delete item.currency.options

        this.add_bonus(item)

        // this.dialog = false
        // this.item = {}
      },

      next: function (step) {
        this.step = step + 1
      },

      loadGames () {
        API.call('/$v/game/list.json', { short: true }).then(resp => {
          this.games.all = resp.data
          this.brands.all = uniq(map(resp.data, 'brand_alias'))
          this.systems.all = uniq(map(resp.data, 'system_alias'))

          this.games.freespins = filter(resp.data, (g) => g.allow_freespins > 0)
          this.brands.freespins = uniq(map(this.games.freespins, 'brand_alias'))
          this.systems.freespins = uniq(map(this.games.freespins, 'system_alias'))
        }).catch(e => {
          console.log(e)
        })
      },
    },

    computed: {
      dialog: {
        get () {
          return this.extdialog
        },
        set (v) {
          this.$emit('update:extdialog', v)
        }
      },
    },

    watch: {
      'steps.settings.form.type': function () {
        this.$set(this.steps.currency.form, 'type', this.steps.settings.form.type)
      },
      dialog (v) {
        this.reset()
        if (v && this.games.all.length == 0) this.loadGames()
      }
    }
  }
</script>


<style lang="scss">

  .bonus-fullscreen-dialog {
    width: calc(100% - 130px);
    max-width: 1300px;
    right: 0;
    position: absolute;
    height: 100%;
    max-height: 100% !important;
    display: flex;
    margin: 0px;
    border-radius: 0px;
  }

</style>
<style scoped lang="scss">
  .bonus-fullscreen-dialog .v-card {
    display: flex;
    flex-direction: column;
    overflow-y: auto;
  }

  .bonus-fullscreen-dialog .v-card .v-card__text {
    flex-grow: 1;
  }

  .bonus-fullscreen-dialog .v-card .v-card__title {
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
  }

  .bonus-fullscreen-dialog .v-card .v-card__actions {
    border-top: thin solid rgba(0, 0, 0, 0.12);
  }

</style>
